import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line import/order
import { READING_AIDS_DIALOG_WIDTH } from '../../../constants';
// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerResultSection: ComponentType<
	{
		isReadingAids?: boolean;
		isExpanded?: boolean;
		serveDefinitionUXExp?: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<{
	isReadingAids?: boolean;
	isExpanded?: boolean;
	serveDefinitionUXExp?: boolean;
}>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isReadingAids, isExpanded, serveDefinitionUXExp }) =>
		isReadingAids
			? {
					font: serveDefinitionUXExp ? token('font.body') : token('font.body.large'),
					color: token('color.text.accent.gray.bolder'),
					maxWidth: serveDefinitionUXExp
						? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
							READING_AIDS_DIALOG_WIDTH
						: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
							`calc(${READING_AIDS_DIALOG_WIDTH} - 40px)`,
					maxHeight: isExpanded ? 'fit-content' : '120px',
					overflowY: 'hidden',
					'@media (max-width: 500px)': {
						maxWidth: 'calc(95vw - 40px)',
					},
				}
			: {
					font: token('font.body'),
					color: token('color.text.accent.gray'),
					overflowY: 'auto',
					width: '100%',
				},
);
